define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump'],
    function ($, transit, modernizr, container, preloader, jumpFactory) {

        const spotifyAddIframeAction = (iframe) => {
            return {
                type: 'SPOTIFY_IFRAME_ADD',
                payload: {
                    spotifyIframe: iframe
                }
            }
        };

        const spotifyIframeReducer = (iframe = null, action) => {
            if (action.type === 'SPOTIFY_IFRAME_ADD') {
                return action.payload.spotifyIframe;
            } else {
                return iframe;
            }
        };

        return (function () {

            const name = 'module-spotify';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                container.getReduxStore().reducerManager.add('spotifyIframe', spotifyIframeReducer);
                container.getReduxStore().dispatch(spotifyAddIframeAction($(view.publicVars.cssId.spotifyPlaylistIframeId)[0]));
            };

            view.bind = function () {

            };

            view.methods = {

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
